var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/victory-core/~/lodash/_Uint8Array.js
// module id = ./node_modules/victory-core/node_modules/lodash/_Uint8Array.js
// module chunks = 1